import { IsNotEmpty, IsOptional, IsIn, IsArray, ValidateNested } from "class-validator";
import { Type } from "class-transformer";

import { IRunningOrder } from "./running-order.interface";
import { RunningOrderDogClassDto } from "./running-order-dog-class.dto";

export class RunningOrderDto implements IRunningOrder {
  //
  @IsNotEmpty()
  judge_name: string;

  @IsOptional()
  judge_number?: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => RunningOrderDogClassDto)
  dog_classes: RunningOrderDogClassDto[];
}
